/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Button, Typography2 } from '@coursera/cds-core';

import { CMLUtils } from 'bundles/cml';
// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import type OnDemandLearnerSessions from 'bundles/naptimejs/resources/onDemandLearnerSessions.v1';

import _t from 'i18n!nls/ondemand';

import 'css!./__styles__/SessionSwitchRow';

type Props = {
  courseId: string;
  session: OnDemandLearnerSessions;
  handleSessionSwitch: (session: OnDemandLearnerSessions) => void;
  showChangesDescription?: (session: OnDemandLearnerSessions) => void;
  isRecommended: boolean;
};

type State = {
  clickedJoin: boolean;
};

const style = {
  enrollmentText: css`
    color: var(--cds-color-grey-200);
  `,
};

class SessionSwitchRow extends React.Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context);
    this.state = { clickedJoin: false };
  }

  handleClickJoin() {
    const { session, handleSessionSwitch, showChangesDescription } = this.props;

    let hasChangesDescription = false;

    if (session.sessionSwitch && session.sessionSwitch.changesDescription) {
      const {
        sessionSwitch: { changesDescription },
      } = session;

      if (changesDescription.cml) {
        hasChangesDescription = !CMLUtils.isEmpty(
          CMLUtils.create(changesDescription.cml.value, changesDescription.cml.dtdId)
        );
      } else {
        hasChangesDescription = !CMLUtils.isEmpty(changesDescription);
      }
    }

    this.setState({ clickedJoin: true });

    if (hasChangesDescription) {
      if (showChangesDescription) {
        showChangesDescription(session);
      }
    } else {
      handleSessionSwitch(session);
    }
  }

  getButtonText() {
    if (this.props.session.isEnrolled) {
      return _t('Enrolled');
    } else if (this.state.clickedJoin) {
      return _t('Joining');
    } else {
      return _t('Join');
    }
  }

  render() {
    const { session, isRecommended } = this.props;
    // allow learners to switch into sessions where enrollment is over
    const isEnrollableNow = (session.enrollmentEnded || session.isEnrollableNow) && session.sessionSwitch.canSwitch;

    return (
      <li className="rc-SessionSwitchRow horizontal-box align-items-vertical-center">
        <Typography2 component="div" className={isRecommended ? '' : 'flex-1'}>
          {session.dateRangeString}
        </Typography2>
        {isRecommended && (
          <Typography2 component="div" className="flex-1 recommended">
            {_t('Recommended')}
          </Typography2>
        )}
        {isEnrollableNow ? (
          <Button
            disabled={session.isEnrolled || this.state.clickedJoin}
            onClick={() => this.handleClickJoin()}
            size="small"
          >
            {this.getButtonText()}
          </Button>
        ) : (
          <Typography2 component="div" css={style.enrollmentText}>
            <FormattedMessage
              message={_t('Enrollment starts {enrollmentStarts}')}
              enrollmentStarts={session.enrollmentStartsAtString}
            />
          </Typography2>
        )}
      </li>
    );
  }
}

export default SessionSwitchRow;
